import React, { forwardRef } from 'react';
import T from 'prop-types';
import cx from 'classnames';

// eslint-disable-next-line prefer-arrow-callback
const CardHeader = forwardRef(function CardHeader({
  children,
  left,
  right,
  disableGutters = false,
  gutters,
  className,
}, ref) {
  return (
    <div
      ref={ref}
      className={cx(
        'hms-card-header',
        disableGutters && 'hms-card-header__no-gutters',
        gutters && `hms-card-header__gutters-${gutters}`,
        className,
      )}
    >
      {left && <div className="hms-card-header__left">{left}</div>}
      {children}
      {right && <div className="hms-card-header__right">{right}</div>}
    </div>
  );
});

CardHeader.propTypes = {
  children: T.node,
  left: T.node,
  right: T.node,
  disableGutters: T.bool,
  // Default gutters size 16px 24px
  // Supported sizes: 16
  // To add support more sizes, add appropriate styles to _hms-card.scss
  // Gutters format for two axis: '16-24'
  gutters: T.oneOfType([T.number, T.string]),
  className: T.string,
};

export default CardHeader;
